import { connect, ConnectedProps } from "react-redux";
import { ReshopSuccessBanner } from "./component";
import { getShowReshopSuccessBanner } from "../../reducer";
import { dismissReshopSuccessBanner } from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  showReshopSuccessBanner: getShowReshopSuccessBanner(state),
});

const mapDispatchToProps = {
  dismissReshopSuccessBanner,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ReshopSuccessBannerConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedReshopSuccessBanner = connector(ReshopSuccessBanner);
